module.exports = __webpack_public_path__ + "img/Microsoft-Authorized-Service-Provider.46acf896.webp";